exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".TopTitle__info___1Oex_ {\n  order: 2;\n  text-align: center;\n}\n@media (min-width: 768px) {\n  .TopTitle__info___1Oex_ {\n    order: 1;\n  }\n}\n.TopTitle__image___3xIRo {\n  order: 1;\n}\n@media (min-width: 768px) {\n  .TopTitle__image___3xIRo {\n    order: 2;\n  }\n}\n.TopTitle__headline___1P8P4 {\n  color: #000;\n  text-transform: lowercase;\n  margin-top: 0px;\n  font-size: 70px;\n  margin-bottom: 10px;\n  line-height: 70px;\n  font-weight: 700;\n}\n.TopTitle__titleWrapper___C7pKy {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  max-width: 1024px;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 10px 0px;\n  position: relative;\n  text-align: center;\n}\n.TopTitle__highlighted___17eFf {\n  color: #007cf9;\n}\n", ""]);

// exports
exports.locals = {
	"info": "TopTitle__info___1Oex_",
	"image": "TopTitle__image___3xIRo",
	"headline": "TopTitle__headline___1P8P4",
	"titleWrapper": "TopTitle__titleWrapper___C7pKy",
	"highlighted": "TopTitle__highlighted___17eFf"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./~/stylus-loader!./src/components/static/TopTitle.styl
// module id = 242
// module chunks = 0